// Modo escrita (§4.2, aceite 13 da fase 4): a mesma nota em tela cheia, Ctrl/Cmd+Shift+F abre e fecha, Esc volta ao
// detalhe. Não cria card: salva no próprio card ao sair (blur antes de fechar = o texto chega ao store antes do detalhe
// remontar o editor dele).
import type { Editor } from "@tiptap/core";
import { useEffect, useRef } from "preact/hooks";
import type { Card, Doc } from "../../../../shared/types.ts";
import { openOver, releaseKeyboard } from "../detail/Extras.tsx";
import { IconClose } from "../Icons.tsx";
import { MOD } from "../Grid.tsx";
import { RichText } from "../RichText.tsx";
import { store } from "../state.ts";

export const isWriterKey = (e: KeyboardEvent) => e.code === "KeyF" && e.shiftKey && (e.ctrlKey || e.metaKey) && !e.altKey;

export function Writer({ card: c, onSave, onClose }: { card: Card; onSave: (doc: Doc, text: string) => void; onClose: () => void }) {
  const ref = useRef<HTMLDialogElement>(null);
  const editor = useRef<Editor | null>(null);
  useEffect(() => {
    // O diálogo abre com o foco no texto (autofocus do editor), cursor no fim. No iPhone o teclado vem do campo que o
    // toque em "Modo escrita" focou (holdKeyboard): o foco passa direto para o editor, sem parar no ×.
    const undo = openOver(ref.current!, false);
    const ed = editor.current;
    if (ed) {
      ed.commands.setTextSelection(ed.state.doc.content.size);
      (ed.view.dom as HTMLElement).focus();
    }
    releaseKeyboard();
    return undo;
  }, []);
  const close = () => {
    (editor.current?.view.dom as HTMLElement | undefined)?.blur(); // flush síncrono do texto
    ref.current?.close();
  };
  return (
    <dialog
      ref={ref}
      class="rd-writer"
      aria-label="Modo escrita"
      onCancel={(e) => {
        e.preventDefault();
        close();
      }}
      onKeyDown={(e) => {
        if (!isWriterKey(e)) return;
        e.preventDefault();
        close();
      }}
      onClose={onClose}
    >
      <div class="rd-writer-glow" aria-hidden="true" />
      <p class="rd-writer-hint">
        Modo escrita <span aria-hidden="true">·</span> <kbd>Esc</kbd> volta <span aria-hidden="true">·</span> <kbd>/</kbd> comandos
      </p>
      <button type="button" class="rd-x rd-writer-x" aria-label="Sair do modo escrita" title={`Sair (Esc ou ${MOD}+Shift+F)`} onClick={close}>
        <IconClose />
      </button>
      <div class="rd-writer-page">
        <RichText
          doc={store.get(c.id)?.content ?? c.content}
          label="Texto da nota (modo escrita)"
          placeholder="Escreva à vontade…"
          links
          slash
          cardId={c.id}
          autofocus
          onSave={onSave}
          onReady={(ed) => (editor.current = ed)}
        />
      </div>
    </dialog>
  );
}
